import React from 'react';
import { Table, TableData, TableRow } from '@cokitchen/cokitchen-components';
import { DeleteIcon } from 'cokitchen-icons';
import CurrencyInput from 'components/base/currency-input';
import SelectDropdown from 'components/base/select-dropdown';
import IngredientSelect from './ingredient-dropdown';
import MixSelect from './mix-dropdown';
import { IngredientListType, IngredientType } from 'models/pricing.model';
import { ENUM_UNIT } from 'models/common.model';

interface ConversionItemsTableProps {
  items: IngredientType[];
  itemType: 'ingredients' | 'packaging';
  tableHeaders: string[];
  isPrepConfig: boolean;
  mealTypeValue?: Record<string, string>;
  onMealTypeChange: (index: number, value: string) => void;
  onInputChange: (
    itemIndex: number,
    value: string | number | ENUM_UNIT,
    name: keyof IngredientType,
    type: 'ingredients' | 'packaging',
    ingredient?: IngredientListType
  ) => void;
  onRemoveItem: (itemIndex: number) => void;
}

const ConversionItemsTable: React.FC<ConversionItemsTableProps> = ({
  items,
  itemType,
  tableHeaders,
  isPrepConfig,
  onMealTypeChange,
  onInputChange,
  onRemoveItem
}) => {
  return (
    <Table headers={tableHeaders}>
      {items.map(
        (
          { name = '', ingredient_name, unit_type, quantity, ingredient, min_vendor_price },
          itemIndex
        ) => {
          return (
            <TableRow key={itemIndex}>
              {!isPrepConfig ? (
                <TableData>
                  <SelectDropdown
                    hasSearch
                    placeholder='Select type'
                    value={items[itemIndex]?.meal_type ?? items[itemIndex]?.type}
                    setValue={(item) => {
                      onMealTypeChange(itemIndex, item.id);
                    }}
                    options={[
                      { name: 'Mix', id: 'mix' },
                      { name: 'Ingredients', id: 'ingredients' }
                    ]}
                  />
                </TableData>
              ) : (
                <div className='hidden' />
              )}
              <TableData>
                {!isPrepConfig && items[itemIndex]?.meal_type === 'mix' ? (
                  <MixSelect
                    {...{
                      handleChange: (e, idx) => {
                        onInputChange(
                          idx,
                          e.rest.name,
                          'ingredient_name',
                          itemType,
                          e.rest.ingredient
                        );
                      },
                      ingredient_name: ingredient_name ?? name ?? '',
                      index: itemIndex
                    }}
                  />
                ) : (
                  <IngredientSelect
                    itemIndex={itemIndex}
                    ingredient_name={ingredient_name ?? name ?? ''}
                    type={itemType}
                    handleInputChange={(itemIdx, value, fieldName, _type, ing) =>
                      onInputChange(itemIdx, value, fieldName, itemType, ing)
                    }
                  />
                )}
              </TableData>

              <TableData>
                <CurrencyInput
                  value={ingredient?.min_vendor_price ?? min_vendor_price ?? ''}
                  onChange={(e) => {
                    console.log(e);
                  }}
                  placeholder=' 2,000'
                  disabled
                />
              </TableData>

              <TableData>
                <CurrencyInput
                  containerClassname='w-[220px]'
                  name='quantity'
                  placeholder=' 2,000'
                  hasUnit
                  hideCurrency
                  value={quantity}
                  unitValue={ingredient?.unit_type ?? unit_type}
                  disableUnit
                  decimalsLimit={2}
                  onChange={(value) => onInputChange(itemIndex, value, 'quantity', itemType)}
                />
              </TableData>
              <TableData>
                <CurrencyInput
                  value={
                    parseFloat(ingredient?.min_vendor_price ?? min_vendor_price ?? '') *
                    Number(quantity)
                  }
                  onChange={(e) => {
                    console.log(e);
                  }}
                  disabled
                  placeholder=' 2,000'
                />
              </TableData>
              <TableData>
                <button
                  onClick={() => onRemoveItem(itemIndex)}
                  className='min-w-[30px] min-h-[30px] max-w-[30px] max-h-[30px] flex justify-center items-center rounded-full hover:bg-[#FEDDE2] ease-in-out duration-300 transition-colors cursor-pointer text-[#E60A2B] '>
                  <DeleteIcon />
                </button>
              </TableData>
            </TableRow>
          );
        }
      )}
    </Table>
  );
};

export default ConversionItemsTable;
